import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Lightweight section label for analytics page zones (site overview vs
 * listing performance). Keeps scope visible without adding another card.
 */
const AnalyticsScopeZone = ({ title, caption, sx = {} }) => (
  <Box sx={{ mb: { xs: 1.25, sm: 1.5 }, ...sx }}>
    <Typography
      sx={{
        fontSize: '0.72rem',
        fontWeight: 600,
        color: 'rgba(0,0,0,0.55)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        lineHeight: 1.2,
      }}
    >
      {title}
    </Typography>
    {caption ? (
      <Typography
        sx={{
          mt: 0.4,
          fontSize: '0.75rem',
          color: 'rgba(0,0,0,0.45)',
          lineHeight: 1.45,
        }}
      >
        {caption}
      </Typography>
    ) : null}
  </Box>
);

export default AnalyticsScopeZone;
